import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { takeUntilDestroyed } from 'src/app/utils/take-until-destroyed';
import { takeUntil } from 'rxjs/operators';
import { LevelOfServiceService } from 'src/app/component/level-of-service/service/level-of-service.service';
import { ChecklistService } from 'src/app/component/spaceType-checklist/checklist-service/checklist.service';
import { sweetAlert } from 'src/app/utils/swal';

@Component({
  selector: 'app-checklist-modal',
  templateUrl: './checklist-modal.component.html',
  styleUrls: ['./checklist-modal.component.css']
})
export class ChecklistModalComponent implements OnInit {
  @Input() tripData;
  @Output() onClose = new EventEmitter<any>();
  preSpaceType = {}
  checkListData = [];
  modalObj;
  constructor(private checklistService: ChecklistService,
    private levelOfServiceService : LevelOfServiceService
  ) { }

  ngOnInit() {
    this.getChecklist();
    console.log("trip Data",this.tripData)

  }

  getChecklist() {
    let queryParams = {
      assign: this.tripData._id
    }
    this.checklistService.getCheckListByAssignId(queryParams)
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.checkListData = data.checklist;
          this.modalObj = data
        }
      });
    this.getSpaceTypeList();
  }

  getSpaceTypeList() {
    this.levelOfServiceService
      .getSpaceTypes({ status: 'active' })
      .pipe(takeUntil(takeUntilDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.preSpaceType = data.reduce((obj, item) => (obj[item._id] = item, obj), {});

        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  onCloseModal(){
    this.onClose.emit();
  }

  ngOnDestroy(): void {
  }

}
